import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';  // Import Pinia
import 'bootstrap/dist/css/bootstrap.min.css'

import 'bootstrap/dist/js/bootstrap.js'

const app = createApp(App);

const pinia = createPinia();  // Create Pinia instance
app.use(pinia);  // Use Pinia in the app
app.use(router);  // Use Vue Router in the app
app.mount('#app');
